// SET_CGU
export const setCgu = (cguData) => ({
  type: 'SET_CGU',
  data: cguData
});


// WEBPACK FOOTER //
// ./src/actions/cgu.js